module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5a308bd1707070ac430b19a7d205ded0.png";